import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
import { Ornament } from './graphics/Graphics';
interface PolicyModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}
export function PolicyModal({
  isOpen,
  onClose,
  title,
  children
}: PolicyModalProps) {
  // Close on ESC
  useEffect(() => {
    if (!isOpen) return;
    const handleKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', handleKey);
    // Lock body scroll
    document.body.style.overflow = 'hidden';
    return () => {
      window.removeEventListener('keydown', handleKey);
      document.body.style.overflow = '';
    };
  }, [isOpen, onClose]);
  return <AnimatePresence data-id="element-405">
      {isOpen && <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} transition={{
      duration: 0.2
    }} className="fixed inset-0 z-[100] flex items-center justify-center p-4 md:p-8" aria-modal="true" role="dialog" aria-labelledby="policy-modal-title" data-id="element-406">
          {/* Backdrop */}
          <div className="absolute inset-0 bg-ink/60 backdrop-blur-sm" onClick={onClose} aria-hidden="true" data-id="element-407" />

          {/* Modal */}
          <motion.div initial={{
        opacity: 0,
        y: 20,
        scale: 0.97
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 20,
        scale: 0.97
      }} transition={{
        duration: 0.25,
        ease: 'easeOut'
      }} className="relative bg-offwhite rounded-xl shadow-2xl w-full max-w-[720px] max-h-[88vh] flex flex-col overflow-hidden border border-divider" data-id="element-408">
            {/* Close button */}
            <button onClick={onClose} className="absolute top-4 right-4 w-9 h-9 rounded-full bg-cream hover:bg-divider transition-colors flex items-center justify-center z-10 text-ink" aria-label="Close" data-id="element-409">
              <X className="w-4 h-4" data-id="element-410" />
            </button>

            {/* Header */}
            <div className="px-6 md:px-10 pt-10 md:pt-12 pb-6 border-b border-divider bg-cream/40" data-id="element-411">
              <div className="font-inter text-[11px] uppercase tracking-[0.2em] text-secondary mb-2" data-id="element-412">
                DryControl™ · UK
              </div>
              <h2 id="policy-modal-title" className="font-playfair text-[24px] md:text-[30px] text-ink font-semibold leading-tight" data-id="element-413">
                {title}
              </h2>
              <div className="mt-4 -mb-2" data-id="element-414">
                <Ornament color="#C9A96E" width={60} data-id="element-415" />
              </div>
            </div>

            {/* Body */}
            <div className="overflow-y-auto px-6 md:px-10 py-8 font-inter text-[15px] text-ink leading-[1.75] policy-body" data-id="element-416">
              {children}
            </div>

            {/* Footer */}
            <div className="px-6 md:px-10 py-4 border-t border-divider bg-cream/40 flex justify-end" data-id="element-417">
              <button onClick={onClose} className="font-inter text-[14px] font-semibold text-forest hover:underline" data-id="element-418">
                Close
              </button>
            </div>
          </motion.div>
        </motion.div>}
    </AnimatePresence>;
}